import React, { useEffect, useRef } from 'react';
import './Particles.css';

export default function Particles({ count = 28 }) {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    for (let i = 0; i < count; i++) {
      const p = document.createElement('div');
      p.className = 'particle';
      const size     = 1 + Math.random() * 2.5;
      const left     = Math.random() * 100;
      const delay    = Math.random() * 18;
      const duration = 14 + Math.random() * 20;
      p.style.cssText = `
        left: ${left}%;
        bottom: -10px;
        width: ${size}px;
        height: ${size}px;
        animation-duration: ${duration}s;
        animation-delay: ${delay}s;
      `;
      container.appendChild(p);
    }

    return () => {
      while (container.firstChild) container.removeChild(container.firstChild);
    };
  }, [count]);

  return <div className="particles" ref={containerRef} />;
}
